<template>
	<TreeSelect v-model="value"
				:label-text="labelText"
				:selected-values-text-multiple="$t('common.select.industry.multiple')"
				:options="industryTreeData"
				options-value-field="naceCode"
				options-key-field="naceCode"
				options-display-field="label"
				:search-allow="true"
				:search-debounce="500"
				content-size="auto"
				auto-max-height="75%"
				:disabled="disabled"
				:required="required"
				:error="error"
				ref="select"
	></TreeSelect>
</template>
<script>
import {commonApi} from "@/common/api/commonApi";
import TreeSelect from "@/components/templates/common/TreeSelect.vue";
import {formatAsIndustryText} from "@/common/format";

export default {
	components: { TreeSelect },
	props: {
		value: { type: Array, default: [] },
		labelText: { type: String },
		disabled: { type: Boolean, default: false },
		required: { type: Boolean, default: false },
		error: { type: Boolean, default: "" },
	},
	data() {
		return {
			industryTreeData: null
		};
	},
	created() {
		this.loadIndustryTree();
	},
	methods: {
		loadIndustryTree() {
			function mapTreeNode(node) {
				return {
					naceCode: node.data.naceCode,
					label: formatAsIndustryText(node.data.naceCode),
					children: node.children.map(mapTreeNode.bind(this))
				};
			}

			commonApi.getIndustryTreeList()
				.then(res => this.industryTreeData = res.map(mapTreeNode.bind(this)))
				.catch(this.toast);
		},
		resetSearch() {
			this.$refs.select.resetSearch();
		}
	},
	watch: {
		value() {
			this.$emit("input", this.value);
		}
	}
};
</script>
